import styled from 'styled-components'; // Reminder Common UI Dialog box heigh is 0.75 * window.innerHeight

const height = 0.71 * window.innerHeight;
export const FormBody = styled.div.withConfig({
  displayName: "WrapperDiv__FormBody",
  componentId: "sc-1y0hvde-0"
})(["", " ", " color:", ";@media print{color:black;background:transparent;}"], props => props.printView ? `margin-bottom: 20px;
         padding-left: 2%;` : `
  background-color: ${props.theme.palette.background.paper};
  width: 100%;
  height: 100%;`, props => props.dialogHeight ? `height: ${height}px;
         padding-left: 2%;` : `;`, props => props.theme.palette.text.primary);
export const TopForm = styled.div.withConfig({
  displayName: "WrapperDiv__TopForm",
  componentId: "sc-1y0hvde-1"
})(["display:flex;flex-direction:row;justify-content:space-between;padding:10px;width:100%;position:sticky;top:0;z-index:2;", ""], props => `background-color: ${props.theme.palette.background.paper};`);
export const Text = styled.div.withConfig({
  displayName: "WrapperDiv__Text",
  componentId: "sc-1y0hvde-2"
})(["display:flex;justify-content:flex-start;align-content:center;align-items:center;"]);
export const DCDiv = styled.div.withConfig({
  displayName: "WrapperDiv__DCDiv",
  componentId: "sc-1y0hvde-3"
})(["display:flex;flex-direction:row;justify-content:space-between;align-items:center;flex-wrap:wrap;width:100%;", ""], props => {
  const {
    paper
  } = props.theme.palette.background;
  return `color: ${paper}`;
});
export const StyledLi = styled.li.withConfig({
  displayName: "WrapperDiv__StyledLi",
  componentId: "sc-1y0hvde-4"
})(["", " ", " ", " padding:3px;@media print{color:black;&:before{color:black;}}"], props => props.horizontal ? `display: flex;` : `;`, props => {
  const {
    secondary
  } = props.theme.palette.text;
  const {
    paper
  } = props.theme.palette.background;
  return props.dc ? `color: ${paper};
      background-color: ${secondary};
      display: flex;
      &:before {
    content: '• ';
    font-size: large;
    color: ${paper};
  }` : `color: ${secondary};
      &:before {
    content: '• ';
    font-size: large;
    color: ${secondary};
  }`;
}, props => {
  const {
    secondary
  } = props.theme.palette.text;
  return props.noBullet ? `color: ${secondary};
      &:before {
    content: '';
    color: ${secondary};
  }` : ';';
}); // pre-line to get line breaks

export const StyledDiv = styled.div.withConfig({
  displayName: "WrapperDiv__StyledDiv",
  componentId: "sc-1y0hvde-5"
})(["", " ", " align-items:center;padding:3px;white-space:pre-line;@media print{color:black;}"], props => props.horizontal ? `display: flex;` : `;`, props => {
  const {
    secondary
  } = props.theme.palette.text;
  const {
    paper
  } = props.theme.palette.background;
  return props.dc ? `color: ${paper};
      background-color: ${secondary};
      display: flex;` : `color: ${secondary};`;
});
export const InputDiv = styled.div.withConfig({
  displayName: "WrapperDiv__InputDiv",
  componentId: "sc-1y0hvde-6"
})(["padding:3px;"]);
export const FormLi = styled.li.withConfig({
  displayName: "WrapperDiv__FormLi",
  componentId: "sc-1y0hvde-7"
})(["width:100%;", " ", " ", " @media print{color:black;&:before{color:black;}}"], props => props.horizontal ? `display: flex;` : `;`, props => {
  const {
    secondary
  } = props.theme.palette.text;
  return props.readOnly ? `color: ${secondary};` : `;`;
}, props => props.bullet ? `display: flex;
      padding-left: 30px;
      &:before {
    content: '• ';
    font-size: large;
  }` : `;`);
export const StyledReadOnlyUl = styled.ul.withConfig({
  displayName: "WrapperDiv__StyledReadOnlyUl",
  componentId: "sc-1y0hvde-8"
})(["list-style-type:none;padding-inline-start:5px;", ""], props => props.horizontal ? `display: flex;` : `;`);
export const ElementDiv = styled.div.withConfig({
  displayName: "WrapperDiv__ElementDiv",
  componentId: "sc-1y0hvde-9"
})(["display:flex;flex-direction:row;justify-content:flex-start;align-items:flex-start;flex-wrap:nowrap;"]);
export const SignatureForm = styled.div.withConfig({
  displayName: "WrapperDiv__SignatureForm",
  componentId: "sc-1y0hvde-10"
})(["max-width:300px;padding:5px;margin:10px 0px;border:1px solid black;"]);
export const SignatureDiv = styled.div.withConfig({
  displayName: "WrapperDiv__SignatureDiv",
  componentId: "sc-1y0hvde-11"
})(["padding:10px;"]);
export const PainMapCanvas = styled.div.withConfig({
  displayName: "WrapperDiv__PainMapCanvas",
  componentId: "sc-1y0hvde-12"
})(["", ""], props => props.validated ? `border: 2px solid blue;` : `;`);
export const FullWidthLi = styled.li.withConfig({
  displayName: "WrapperDiv__FullWidthLi",
  componentId: "sc-1y0hvde-13"
})(["width:100%;"]);
export const FormNameDiv = styled.div.withConfig({
  displayName: "WrapperDiv__FormNameDiv",
  componentId: "sc-1y0hvde-14"
})(["font-size:1.2rem;font-weight:600;"]);
export const SavingDiv = styled.div.withConfig({
  displayName: "WrapperDiv__SavingDiv",
  componentId: "sc-1y0hvde-15"
})(["width:100%;display:flex;flex-direction:row;justify-content:center;align-items:center;background-color:rgba(129,199,132,0.5);color:white;min-height:30px;height:80%;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);-webkit-border-radius:4px;"]);